import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import { Footer } from './Footer';
import Header from './Header';

export const Layout: React.FC = () => {
  const location = useLocation();
  const isMainPage = location.pathname === '/';
  
  // Detect landscape orientation on mobile/tablet devices
  const isSmallScreen = useMediaQuery('(max-width: 900px)');
  const isShortScreen = useMediaQuery('(max-height: 600px)');
  const isOrientationLandscape = useMediaQuery('(orientation: landscape)');
  const isLandscape = (isSmallScreen || isShortScreen) && isOrientationLandscape;

  // Always use the same grid layout and header for all pages
  return (
    <div 
      className="App" 
      style={{ 
        height: '100dvh',
        width: '100vw',
        display: 'grid',
        gridTemplateRows: isLandscape ? '10vh 1fr' : '10vh 1fr 5vh', // Hide footer row in landscape
        gridTemplateColumns: '1fr',
        gridTemplateAreas: isLandscape ? `
          "header"
          "content"
        ` : `
          "header"
          "content"
          "footer"
        `,
        overflow: 'hidden'
      }}
    >
      {/* Header - Always the same, but profile selector only appears when passed props from child components */}
      <div style={{ 
        gridArea: 'header',
        height: '100%',
        display: 'flex',
        alignItems: 'stretch'
      }}>
        <Header />
      </div>

      {/* Main Content */}
      <Box
        sx={{
          gridArea: 'content',
          overflow: isMainPage ? 'hidden' : 'auto',
          position: 'relative',
          // Ensure proper mobile scrolling for legal pages
          WebkitOverflowScrolling: 'touch',
          // Add safe area padding for mobile devices on legal pages
          paddingBottom: { xs: isMainPage ? 0 : 'env(safe-area-inset-bottom, 0)', sm: 0 }
        }}
      >
        <Outlet />
      </Box>

      {/* Footer - Hidden in landscape mode on mobile */}
      {!isLandscape && (
        <div style={{ 
          gridArea: 'footer', 
          paddingBottom: 'env(safe-area-inset-bottom, 0)',
          boxSizing: 'border-box',
          display: 'flex',
          overflow: 'visible'
        }}>
          <Footer />
        </div>
      )}
    </div>
  );
};
